export function useInfiniteScroll(callback: () => void) {
  const targetRef = ref<HTMLElement | null>(null)
  const observer = ref<IntersectionObserver | null>(null)

  const createObserver = () => {
    observer.value = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          callback()
        }
      })
    })
  }

  onMounted(() => {
    createObserver()
    if (targetRef.value) {
      observer.value?.observe(targetRef.value)
    }
  })

  onBeforeUnmount(() => {
    unobserve()
  })

  function unobserve() {
    if (targetRef.value) {
      observer.value?.unobserve(targetRef.value)
    }
    observer.value?.disconnect()
  }

  return {
    targetRef,
    unobserve,
  }
}
